import React from 'react'
import ReactDOM from 'react-dom'

import { Pile } from '@/components-latest/ui/Toaster/Pile/Pile'
import { SoloToast } from '@/components-latest/ui/Toaster/SoloToast/SoloToast'
import {
  GAP,
  TOAST_WIDTH,
  VIEWPORT_OFFSET,
  VISIBLE_TOASTS_AMOUNT
} from '@/components-latest/ui/Toaster/Toaster.constants'
import { HeightT } from '@/components-latest/ui/Toaster/Toaster.types'
import { useToaster } from '@/components-latest/ui/Toaster/useToaster/useToaster'
import { INotification } from '@/ducks/notifications/slices/notification.slice'

import Styles from './Toaster.module.scss'

const offset = VIEWPORT_OFFSET
const gap = GAP
const containerAriaLabel = 'Notifications'

const Toaster = () => {
  const [systemToasts, setSystemToasts] = React.useState<INotification[]>([])
  const [orderToasts, setOrderToasts] = React.useState<INotification[]>([])
  const [heights, setHeights] = React.useState<HeightT[]>([])
  const [frontHeight, setFrontHeight] = React.useState(0)
  const [interacting, setInteracting] = React.useState(false)
  const [expanded, setExpanded] = React.useState(false)
  const listRef = React.useRef<HTMLUListElement>(null)

  const { removeToast, system, newOrders } = useToaster()

  const handleRemoveToast = React.useCallback(
    (toastToRemove: INotification) => {
      removeToast(toastToRemove.id)
    },
    [removeToast]
  )

  React.useEffect(() => {
    setTimeout(() => {
      ReactDOM.flushSync(() => {
        setSystemToasts([...system].reverse())
      })
    })
  }, [system])

  React.useEffect(() => {
    setTimeout(() => {
      ReactDOM.flushSync(() => {
        setOrderToasts([...newOrders].reverse())
      })
    })
  }, [newOrders])

  if (!systemToasts.length && !orderToasts.length) return null

  return (
    <section aria-label={`${containerAriaLabel}`} tabIndex={-1}>
      <div
        className={Styles.toaster}
        style={
          {
            '--offset':
              typeof offset === 'number'
                ? `${offset}px`
                : offset || VIEWPORT_OFFSET,
            '--width': `${TOAST_WIDTH}px`,
            '--gap': `${gap}px`
          } as React.CSSProperties
        }>
        <ul className={Styles.toastList} tabIndex={-1} ref={listRef}>
          {systemToasts.map(function (systemToast, index, arr) {
            return (
              <SoloToast
                expanded={expanded}
                key={systemToast.id}
                index={index}
                toast={systemToast}
                toasts={arr}
                interacting={interacting}
                onToastRemove={handleRemoveToast}
                heights={heights}
                setHeights={setHeights}
                gap={gap}
                pileOffset={frontHeight}
              />
            )
          })}
          <Pile
            systemToastsLength={systemToasts.length}
            toasts={orderToasts}
            setFrontHeight={setFrontHeight}
            offset={VIEWPORT_OFFSET}
            visibleToasts={VISIBLE_TOASTS_AMOUNT}
            gap={gap}
            expanded={expanded}
            setExpanded={setExpanded}
            onToastRemove={handleRemoveToast}
          />
        </ul>
      </div>
    </section>
  )
}

export { Toaster }

export default Toaster
